<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="row">
      <billing-settings></billing-settings>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import BillingSettings from './components/BillingSettings'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'MainBillingSettings',
    components: { BillingSettings, Breadcrumb },
    data () {
      return {
        selectedBillingSetting: '',
        index: '',
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.billing_settings'),
          'paths': {
            0: {
              'title': this.$t('settings.main.setup'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadBillingSettings', 'updateBillingSetting', 'loadBillingSetting']),
      ...mapMutations(['setBillingSettings']),
      submitForm () {
        if (this.selectedBillingSetting === '23') {
          this.billingSetting.value = +!!this.billingSetting.value
        }
        var params = { id: this.selectedBillingSetting, value: this.billingSetting.value }
        this.$loader.show()
        this.updateBillingSetting(params).then(this.afterLoadBillingSetting)
      },
      getBillingSetting () {
        this.loadBillingSetting(this.selectedBillingSetting).then(this.afterLoadBillingSetting)
      },
      afterLoadBillingSetting () {
        this.$loader.hide()
        scroll.scrollToFlash()
      },
      getBillingSettings () {
        this.$loader.show()
        this.loadBillingSetting('1').then(this.afterLoadBillingSettings)
      },
      afterLoadBillingSettings () {
        if (this.billingSettings === undefined) {
          this.selectedBillingSetting = '1'
        } else {
          this.selectedBillingSetting = this.billingSettings.id
        }
        this.getBillingSettingConfigs()
      },
      getBillingSettingConfigs () {
        this.loadBillingSetting(this.selectedBillingSetting).then(this.afterLoadBillingSetting)
      }
    },
    computed: {
      ...mapGetters(['billingSetting'])
    },
    mounted () {
      this.getBillingSettings()
    }
  }
</script>



// WEBPACK FOOTER //
// MainBillingSettings.vue?3ea642f9